export const WIZARD_ANALYTICS_EVENTS = {
  EVENT_FORMAT_SELECTED: 'event_format_selected',
  STEP_SKIPPED: 'step_skipped',
  MODAL_CLOSED: 'modal_closed',
  EVENT_SETUP_CREATE: 'event_setup_create',
  EVENT_PUBLISHED: 'event_creation_wizard_event_published',
  EVENT_SETUP_SUCCESSFUL: 'event_creation_wizard_event_created',
  EVENT_SETUP_UNSUCCESSFUL: 'event_setup_unsuccessful',
  BACK_BUTTON_PRESSED: 'back_button_pressed',
  STEP_VISITED: 'event_wizard_step_visited',
} as const;

export type WizardAnalyticsEvents =
  (typeof WIZARD_ANALYTICS_EVENTS)[keyof typeof WIZARD_ANALYTICS_EVENTS];
